module.exports = __webpack_public_path__ + "img/icon_strategy.de961571.a77c689d.svg";